import React from 'react';
import { DateTime } from 'luxon';
import { Fieldset, Input } from '@flixbus/honeycomb-react';

import { useVoucherFormContext } from '../../../Context';
import { Asterisk } from '../../../Asterisk';

import { getNextYearDateOnly, toISODate } from '../../../../../helpers/dateTime';

const VoucherFormValidSince: React.FC<{ disabled: boolean; busPartner: boolean }> = ({
  disabled,
  busPartner,
}) => {
  const {
    formState: {
      payload: { validSince },
    },
    handlePayloadChange,
  } = useVoucherFormContext();

  const dateObject = validSince ? DateTime.fromISO(validSince) : null;
  const maxDate = busPartner ? getNextYearDateOnly() : undefined;
  return (
    <Fieldset itemSpacing='half'>
      <Input
        name='date-field-validSince'
        id='date-field-validSince'
        label={<>Voucher valid from {!disabled && <Asterisk />}</>}
        type='date'
        min={new Date().toISOString().split('T')[0]}
        max={maxDate}
        disabled={disabled}
        required
        info={`The validity starts at 00:00 GMT${DateTime.local().toFormat('ZZ')}`}
        value={dateObject ? dateObject.setLocale('de').toFormat('yyyy-MM-dd') : ''}
        onChange={e => {
          const { value } = e.target;

          if (value === '') {
            const date = new Date();
            handlePayloadChange({
              value: toISODate(DateTime.fromJSDate(date)),
              prop: 'validSince',
            });
          } else {
            const date = new Date(value);
            handlePayloadChange({
              value: toISODate(DateTime.fromJSDate(date)),
              prop: 'validSince',
            });
          }
        }}
      />
    </Fieldset>
  );
};

export default VoucherFormValidSince;
